// #2091 — the empty `DataModelsUiModule` NgModule scaffold was deleted: it was
// imported (without effect) by exactly one consumer (calendar-ui.module.ts) and
// its `@angular/core` runtime import was the ONLY thing preventing backend
// projects from importing this barrel under Jest (@angular ships ESM-only,
// which the backend ts-jest/node runtime cannot parse). Everything else in
// this lib is interfaces, constants, and framework-free utils — Angular types
// appear via `import type` only (compile-time-erased), keeping this the one
// lib both Nx graphs can consume (see ct-time.util.ts).
export * from './lib/admin';
export * from './lib/admin-dashboard';
export * from './lib/auth';
export * from './lib/activities';
export * from './lib/account-details';
export * from './lib/address-details';
export * from './lib/booking';
export * from './lib/checkout';
export * from './lib/club';
export * from './lib/clientHistory';
export * from './lib/customer';
export * from './lib/customer-account';
export * from './lib/common';
export * from './lib/ct-time.util';
export * from './lib/time-format.util';
export * from './lib/customer-testing';
export * from './lib/currentStatusGoals';
export * from './lib/dashboard';
export * from './lib/discounts';
export * from './lib/email';
export * from './lib/goal';
export * from './lib/license';
export * from './lib/mealplan';
export * from './lib/notifications';
export * from './lib/operator';
export * from './lib/operator-event-format.util';
export * from './lib/payment';
export * from './lib/orders';
export * from './lib/products';
export * from './lib/profile-details';
export * from './lib/profile';
export * from './lib/region';
export * from './lib/service-catalog';
export * from './lib/services';
export * from './lib/settings';
export * from './lib/singup';
export * from './lib/sms';
export * from './lib/signup-lookup';
export * from './lib/state';
export * from './lib/tenant';
export * from './lib/testing-events';
export * from './lib/testing-event-details';
export * from './lib/test-report';
export * from './lib/truck';
export * from './lib/user';

export * from './lib/ui/form';
export * from './lib/ui/generic-table';
export * from './lib/ui/chart';
